import './RecordSecondaryInfo.scss';
import { Col } from 'antd';
import { getSonarObjectTypeAndSourceLabel } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { When } from 'react-if';
export const SonarRecordSecondaryInfo = ({ info, sonarObjectType }) => React.createElement(When, { condition: Boolean(info) || sonarObjectType },
    React.createElement(Col, { className: 'secondary-info', flex: 'auto' },
        React.createElement(When, { condition: sonarObjectType },
            React.createElement("div", null, getSonarObjectTypeAndSourceLabel(sonarObjectType))),
        React.createElement(When, { condition: Boolean(info) },
            React.createElement("div", null, info))));
